export class ScriptGenerator {
  public static createBaseUrlLink(appBaseUrl: string) {
    const linkElement = document.createElement('link');
    linkElement.rel = 'preconnect';
    linkElement.href = appBaseUrl;

    return linkElement;
  }

  public static createLocalGTagScript(
    nonceValue: string,
    debugMode: boolean,
    trackerId: string
  ) {
    const gtagEl = document.createElement('script');
    gtagEl.setAttribute('nonce', nonceValue);
    const gtagBody = document.createTextNode(`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag("js", new Date());

      ${debugMode && trackerId ? `gtag('config', '${trackerId}', { debug_mode: ${debugMode} });` : ''}
    `);

    gtagEl.appendChild(gtagBody);

    return gtagEl;
  }

  public static createGoogleTagManagerScript(
    trackerId: string,
    nonceValue: string
  ) {
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + trackerId;
    script.async = true;
    script.setAttribute('nonce', nonceValue);
    // Prevent blocked script from propagating errors (e.g. ad blockers)
    script.onerror = () => {
      console.warn('Google Tag Manager script blocked or failed to load.');
    };

    return script;
  }
}
